import React from 'react'
import { LibraryItem } from '../../types/LibraryItem'
import { FileInput } from './LibraryInputs/FileInput'
import { Inputs } from './LibraryInputs/Inputs'


export const LibraryForm = ({ title, description, image, pdf, link , item }: Props) => {
    return (
        <div className='grid col-span-5 grid-cols-3 gap-y-3 p-6'>
            {title &&
                <Inputs label={title}  defaultValue={item?.title} name='title' />
            }
            {description &&
                <Inputs label={description} defaultValue={item?.description} name='description' />
            }
            {image &&
                <FileInput image label={image}/>
            }
            {pdf &&
                <FileInput label={pdf}  />
            }
            {link && 
                <Inputs label={link} defaultValue={item?.link} name="link" placeholder='http://www...'/> 
            }   
        </div>
    )
}

interface Props {
    title?: string
    description?: string
    image?: string
    pdf?: string
    link?: string
    item?:LibraryItem
}